import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler } from "../../app/SliceUtils";

export const fetchInformation = createAsyncThunk(
    '/api/information',
    (_, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/information`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const fetchInformationArticle = createAsyncThunk(
    '/api/information/id',
    (id, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/information/${id}`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const informationSlice = createSlice({
    name: "information",
    initialState: {
        information: { data: null, status: null },
        informationArticle: { data: null, status: null },
    },
    reducers: {},
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchInformation, 'information');
        CreateAsyncStatusHandler(builder, fetchInformationArticle, 'informationArticle');
    },
});

export default informationSlice.reducer;
